import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../api";
import useValidations from "../../../utils/hooks/useValidations";
import useRoutes from "../../../routes/useRoutes";
import { useDispatch } from "react-redux";
import { updateConfig } from "../../../store/slices/Global";

const useAuth = (emailRef) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { validateEmail } = useValidations();

  const [loginStatus, setLoginStatus] = useState("idle");
  const [loginInfo, setLoginInfo] = useState({});
  const [showPassword, setShowPassword] = useState(true);
  const [forgotPasswordStatus, setForgotPasswordStatus] = useState("idle");

  const { allowedDashboardComponent } = useRoutes();

  useEffect(() => {
    if (loginStatus === "success") {
      dispatch(
        updateConfig((state) => {
          state.isLogged = true;
        })
      );
      navigate(
        `/${allowedDashboardComponent?.map((item) => item?.path)?.[0]}`
      );
      // window.location.reload()
      // setTimeout(() => {
      //    window.location.reload()
      // }, 100);
    } else if (loginStatus === "failed") {
      let errorFields = Object.keys(loginInfo);
      errorFields.forEach((field) => {
        formik.setFieldError(field, loginInfo[field]);
      });
    }
    // eslint-disable-next-line
  }, [loginStatus]);

  const formik = useFormik({
    initialValues: {
      user_name: "",
      password: "",
    },
    validate: (values) => {
      let errors = {};
      
      if (!values.user_name) {
        errors.user_name = "*User Name required";
      }
      if (!values.password) {
        errors.password = "*Password required";
      }
      if(values.user_name) {
        if (!validateEmail(values.user_name)) {
          errors.user_name = "*Enter a valid email";
        }
      }
      
      
      return errors;
    },
    onSubmit: (values) => {
      emailRef.current = values.user_name;

      setLoginStatus("pending");

      login(values).then((response) => {
        if (response.data.success) {
        

          setLoginInfo(response?.data?.data);
          localStorage.setItem("USER_DETAILS", response?.data?.data?.id);

          localStorage.setItem(
            "USER_ACCESS_TOKEN",
            response?.data?.data?.token
          );
          setLoginStatus("success");
        } else {
          if (response?.message !== "") {
            setLoginStatus("failed");
            setLoginInfo({
              password: `Invalid Credentials`,
            });
          } else {
            setLoginStatus("failed");
            setLoginInfo({
              password:
                "An error occurred during login. Please try again later.",
            });
          }
        }
      });
    },
  });

  const handleForgotPassword = () => {
    navigate(`/login/forgot-password/capture-email`);
  };

  const handleShowPassword = (e) => {
    e.preventDefault();

    setShowPassword(!showPassword);
    var x = document.getElementById("password");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  };

  return {
    formik,
    loginStatus,
    forgotPasswordStatus,
    showPassword,
    handleShowPassword,
    setForgotPasswordStatus,
    handleForgotPassword,
  };
};

export default useAuth;
